module.exports = __webpack_public_path__ + "img/icon-reg-cash-payment.3feaf9e9.png";